import { Component, AfterViewInit, ChangeDetectorRef, ViewRef } from "@angular/core";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { MenuParametrage } from "./menu-parametrage";
import { first } from "rxjs/operators";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";

@Component({
  selector: "app-side-bar-parametrage",
  templateUrl: "./side-bar-parametrage.component.html",
  styleUrls: ["./side-bar-parametrage.component.scss"],
  animations: [
    trigger("slide", [
      state("up", style({ height: 0 })),
      state("down", style({ height: "*" })),
      transition("up <=> down", animate(200)),
    ]),
  ],
})
export class SideBarParametrageComponent implements AfterViewInit {
  currentEmployee: Employee = new Employee();

  MyPermissions: string[];

  menus = [];

  constructor(
    public sidebarservice: MenuParametrage,
    private _keycloakService: KeycloakService,
    private _employeeService: EmployeeService,
    private cdr: ChangeDetectorRef
  ) {
    this.getCurrentEmployee();
    this.menus = sidebarservice.getMenuList();
    this.MyPermissions = _keycloakService.getAccessPermissions();
  }

  ngAfterViewInit() {
    this.toggleActiveLink();
  }

  getCurrentEmployee() {
    this._employeeService.getCurrentEmployee().subscribe(
      (data) => {
        this.currentEmployee = data;
        const view = this.cdr as ViewRef;
        if (view && !view.destroyed) {
          this.cdr.detectChanges();
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getSideBarState() {
    return this.sidebarservice.getSidebarState();
  }

  getState(currentMenu) {
    if (currentMenu.active == "open") {
      return "down";
    } else {
      return "up";
    }
  }

  toggle(currentMenu) {
    this.menus.forEach((element) => {
      if (element === currentMenu) {
        currentMenu.active = "open";
      } else {
        element.active = "";
      }
    });
  }

  toggleSubmenu(currentMenu, subMenu) {
    this.toggle(currentMenu);

    currentMenu.submenus.forEach((element) => {
      if (element === subMenu) {
        subMenu.active = "active";
      } else {
        element.active = "";
      }
    });
  }

  /**
   *
   */

  toggleActiveLink() {
    const link = String(window.location.href);

    this.menus.forEach((element) => {
      if (element.type === "dropdown") {
        let currentMenu = null;
        let subMenu = element.submenus.find(
          (y) => window.location.origin + "/#" + y.Url == link
        );

        if (subMenu != null) {
          currentMenu = element;

          currentMenu.submenus.forEach((elem) => {
            if (elem === subMenu) {
              currentMenu.active = "open";
              subMenu.active = "active";
            }
          });
        }
      }

      if (
        element.type === "simple" &&
        window.location.origin + "/#" + element.Url === link
      ) {
        element.active = "open";
      }
    });
    
    // Forcer la détection des changements
    this.cdr.detectChanges();
  }
}
